module.exports = __webpack_public_path__ + "img/img69.68b4f1b7.png";